import React, { useCallback, useEffect, useState, useContext, useRef } from 'react';
import * as utils from "../../../components/utils.js";
import Editor from '@monaco-editor/react';

const RemoteSource_Editor = ({ node, files, macros, sources, parent, onChange }) => {
    const [item, setItem] = useState(node);
    const [dataLanguage, setDataLanguage] = useState(null);

    const _notifyChange = () => {
        if (onChange) {
            onChange(item);
        }
    }

    useEffect(() => {
        window.$("#ai_source_selector").select2({ dropdownParent: window.$(`#${parent}`) });
        window.$("#ai_source_selector").off("macro");
        window.$("#ai_source_selector").on("change", (e) => {
            item.source = e.target.value ? e.target.value : null;
            setItem(utils.clone(item));
            _notifyChange();
            setDataLanguage(null);
            setTimeout(() => {
                _setDataLanguage();
            }, 1000);

        });
    }, []);

    useEffect(() => {
        //nop
    }, [dataLanguage]);

    useEffect(() => {
        //nop
    }, [item]);

    const _setDataLanguage = () => {
        const _type = sources.find(x => x.file.Id == item.source)?.type;
        switch (_type) {
            case "sql":
            case "mysql":
            case "oracle":
                {
                    setDataLanguage("sql");
                }
                break;
            case "mongo":
            case "api":
                {
                    setDataLanguage("json");
                }
                break;
            default: {
                setDataLanguage(null);
            }
                break;
        }
    }

    useEffect(() => {
        _setDataLanguage();
    }, []);

    return (
        <div>
            <div class="form-group">
                <label for="ai_editor_name">Name</label>
                <input type="text" className="form-control" id="ai_editor_name" aria-describedby="ai_editor_name_help" placeholder="Enter the name"
                    value={item.name} onChange={(e) => {
                        item.name = e.target.value;
                        setItem(utils.clone(item));
                        _notifyChange();
                    }}
                />
                <div class="form-text" >The name used for flows and macros for output data will be: <strong>{utils.code_name(item.name)}</strong></div>
            </div>
            <br></br>
            <div class="form-group">
                <label for="ai_source_selector">Execute this macro</label>
                <select id="ai_source_selector" value={item.macro} onChange={(e) => {
                    item.source = e.target.value ? e.target.value : null;
                    setItem(utils.clone(item));
                    _notifyChange();
                }}>
                    {
                        [(<option value="">not defined</option>)].concat(
                            sources.map((f) => {
                                return (<option value={f.file.Id}>{f.name}</option>);
                            }))}
                </select>
            </div>
            <hr></hr>
            {
                (item.source && dataLanguage ? (<Editor
                    height="50vh"
                    defaultLanguage={dataLanguage}
                    theme='vs-dark'
                    defaultValue={item.code ?? ""}
                    onChange={(e) => {
                        item.code = e ? e : null;
                        setItem(utils.clone(item));
                        _notifyChange();
                    }}
                />) : (null))
            }
        </div>);
}

export { RemoteSource_Editor }